/* eslint-disable import/prefer-default-export */
import React from 'react'
import ContentLoader from 'react-content-loader'

export const ProductItem = () => (
  <ContentLoader
    animate={false}
    viewBox="0 0 330 510"
    backgroundColor="#f3f3f3"
    foregroundColor="#f3f3f3"
  >
    <rect x="0" y="0" width="330" height="440" />
    <rect x="0" y={450} width="330" height="18" />
    <rect x="0" y={450 + 18 + 10} width="150" height="26" />
  </ContentLoader>
)

export const CollectionSkeleton = ({
  className,
  count = 8,
}: {
  className?: string
  count?: number
}) => (
  <div className={`grid grid-cols-2 md:grid-cols-4 -mx-2 ${className}`}>
    {Array(count)
      .fill(0)
      .map((_, idx) => (
        <div className="mx-2 mb-5" key={idx}>
          <ProductItem />
        </div>
      ))}
  </div>
)

export const PagesSkeleton = ({ isPC = false }: { isPC?: boolean }) => (
  <ContentLoader
    rtl
    speed={2}
    className="w-full h-full"
    viewBox={`0 0 ${isPC ? '1065 1008' : '686 850'}`}
    backgroundColor="#f3f3f3"
  >
    {isPC ? (
      <path d="M 0 64 h 1065 v 16 H 0 z M 0 448 h 1065 v 16 H 0 z M 0 832 h 1065 v 16 H 0 z M 0 152 h 1065 v 16 H 0 z M 0 536 h 1065 v 16 H 0 z M 0 920 h 1065 v 16 H 0 z M 0 88 h 1065 v 16 H 0 z M 0 472 h 1065 v 16 H 0 z M 0 856 h 1065 v 16 H 0 z M 0 176 h 1065 v 16 H 0 z M 0 560 h 1065 v 16 H 0 z M 0 944 h 1065 v 16 H 0 z M 0 200 h 1065 v 16 H 0 z M 0 584 h 1065 v 16 H 0 z M 0 968 h 1065 v 16 H 0 z M 0 264 h 1065 v 160 H 0 z M 0 648 h 1065 v 160 H 0 z M 0 112 h 817 v 16 H 0 z M 0 496 h 817 v 16 H 0 z M 0 880 h 817 v 16 H 0 z M 0 224 h 560 v 16 H 0 z M 0 608 h 560 v 16 H 0 z M 0 992 h 560 v 16 H 0 z M 232 0 h 600 v 32 H 232 z" />
    ) : (
      <path d="M 136 0 h 414 v 56 H 136 z M 0 100 h 686 v 42 H 0 z M 0 412 h 349 v 42 H 0 z M 0 578 h 349 v 42 H 0 z M 0 163 h 686 v 209 H 0 z M 0 475 h 686 v 19 H 0 z M 0 515 h 686 v 19 H 0 z M 0 641 h 686 v 209 H 0 z" />
    )}
  </ContentLoader>
)

export const ProductSkeleton = ({ isPC = false }: { isPC?: boolean }) => (
  <ContentLoader
    // speed={2}
    animate={false}
    className="w-full h-full"
    viewBox={`0 0 ${isPC ? '1408 911' : '750 1316'}`}
    backgroundColor="#f3f3f3"
    foregroundColor="#f3f3f3"
  >
    {isPC ? (
      <path d="M 94 0 h 685 v 911 H 94 z M 0 114 h 71 v 96 H 0 z M 0 226 h 71 v 96 H 0 z M 0 338 h 71 v 96 H 0 z M 0 0 h 71 v 96 H 0 z M 854 14 h 552 v 24 H 854 z M 854 53 h 165 v 24 H 854 z M 854 94 h 165 v 24 H 854 z M 854 181 h 165 v 24 H 854 z M 1294 181 h 112 v 24 h -112 z M 854 124 h 370 v 40 H 854 z M 854 210 h 552 v 36 H 854 z M 854 258 h 552 v 62 H 854 z M 854 353 h 552 v 152 H 854 z M 854 530 h 552 v 44 H 854 z M 854 592 h 552 v 148 H 854 z M 854 754 h 552 v 110 H 854 z" />
    ) : (
      <path d="M 0 0 h 82 v 773 H 0 z M 90 0 h 570 v 773 H 90 z M 668 0 h 82 v 773 h -82 z M 24 793 h 450 v 40 H 24 z M 684 793 h 42 v 40 h -42 z M 24 853 h 179 v 52 H 24 z M 24 932 h 179 v 28 H 24 z M 493 862 h 233 v 28 H 493 z M 549 1067 h 177 v 28 H 549 z M 24 1067 h 104 v 28 H 24 z M 24 975 h 570 v 64 H 24 z M 24 1111 h 702 v 64 H 24 z M 24 1182 h 702 v 134 H 24 z" />
    )}
  </ContentLoader>
)
